import { render } from "./NotificationTemplateModal.vue?vue&type=template&id=66c19518"
import script from "./NotificationTemplateModal.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__